/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CitiesService {
    /**
     * List all cities
     * Get a paginated list of cities, optionally filtered by state
     * @param stateId Filter by state ID
     * @param search Search by city name
     * @param perPage Items per page
     * @returns any List of cities
     * @throws ApiError
     */
    public static a98960203C8028B92C060C3Df72D886(
        stateId?: number,
        search?: string,
        perPage: number = 15,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cities',
            query: {
                'state_id': stateId,
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Get a specific city
     * Retrieve details of a specific city
     * @param id City ID
     * @returns any City details
     * @throws ApiError
     */
    public static b63E63C5142F261F2B76A2D432679D3(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cities/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `City not found`,
            },
        });
    }
}
